<template>
    <div>
        <compWrapper
            :title="
                $t('boss.purchase.basic_information_purchase_order', {
                    defaultValue: '采购单基本信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('boss.purchase.delivery_record', {
                    defaultValue: '交货记录',
                })
            "
            theme="primary"
        >
            <TableList class="margin-15" v-bind="getDeliverData"></TableList>
        </compWrapper>
        <compWrapper
            :title="
                $t('boss.purchase.create_delivery', {
                    defaultValue: '创建交货',
                })
            "
            theme="primary"
        >
            <div class="text-right margin-15">
                <vButton theme="success" @click="importexcel">{{
                    $t("boss.purchase.info", { defaultValue: "导入" })
                }}</vButton>
            </div>
            <vTable
                class="margin-15"
                :columns="creacolumns"
                :data="creaformList"
                size="small"
                ref="tablequery"
                border
            ></vTable>
        </compWrapper>
        <!-- 全局loading -->
        <vLoading size="large" transfer :loading="loading"></vLoading>
        <div class="text-right margin-bottom-20">
            <vButton theme="primary" @click="submit">{{
                $t("boss.purchase.save", { defaultValue: "保存" })
            }}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{
                $t("boss.purchase.cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>

        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetOrderOne,
    HttpGetDeliverOne,
    HttpSaveDeliver,
    HttpGetDeliverList,
} from "@/service/purchase/purchase";
import TableList from "@components/templates/tablelist";

export default {
    props: ["activeid", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compUpload: () => import("@components/templates/upload"),
        TableList,
    },
    data() {
        return {
            id: this.$route.query.id,
            formData: {},
            delyformList: [],
            creaformList: [],
            loading: false,
            operate: {
                title: "",
                show: false,
                actionurl: "",
                boxtype: "",
                downexcel: "",
                component: null,
            },
        };
    },
    created() {
        this.update();
    },
    computed: {
        ...mapGetters("diction", [
            "getNewProductList",
            "getAllCurrency",
            "getAllSupplier",
            "getNewDifferentAllProductList",
        ]),
        getBase() {
            return [
                {
                    label: this.$t("boss.purchase.purchase_order_number", {
                        defaultValue: "采购单编号",
                    }),
                    key: "orderNo",
                },
                {
                    label: this.$t("boss.purchase.document_status", {
                        defaultValue: "单据状态",
                    }),
                    key: "orderStatus",
                    tag: "vSelect",
                    options: [
                        {
                            value: "draft",
                            label: this.$t("boss.purchase.draft", {
                                defaultValue: "草稿",
                            }),
                            theme: "darkgray",
                        },
                        {
                            value: "submit",
                            label: this.$t("boss.purchase.submitted", {
                                defaultValue: "已提交",
                            }),
                            theme: "primary",
                        },
                        {
                            value: "auditing_pass",
                            label: this.$t("boss.purchase.approved", {
                                defaultValue: "审核通过",
                            }),
                            theme: "success",
                        },
                        {
                            value: "finished",
                            label: this.$t("boss.purchase.completed", {
                                defaultValue: "已完成",
                            }),
                            theme: "",
                        },
                        {
                            value: "canceled",
                            label: this.$t("boss.purchase.cancelled", {
                                defaultValue: "已取消",
                            }),
                            theme: "warning",
                        },
                        {
                            value: "auditing_refused",
                            label: this.$t("boss.purchase.review_rejected", {
                                defaultValue: "审核驳回",
                            }),
                            theme: "error",
                        },
                    ],
                },
                {
                    label: this.$t("boss.purchase.supplier", {
                        defaultValue: "供应商",
                    }),
                    key: "supplierId",
                    tag: "vSelect",
                    options: this.getAllSupplier,
                },
                {
                    label: this.$t("boss.purchase.project", {
                        defaultValue: "项目",
                    }),
                    key: "lineId",
                    tag: "vSelect",
                    options: this.getNewProductList,
                },
                {
                    label: this.$t("boss.purchase.batch_number", {
                        defaultValue: "批次号",
                    }),
                    key: "refNo",
                },
                {
                    label: this.$t("boss.purchase.estimated_delivery_date", {
                        defaultValue: "预计交货日期",
                    }),
                    key: "expectedDeliveryDate",
                },
                {
                    label: this.$t("boss.purchase.procurement_model", {
                        defaultValue: "采购模式",
                    }),
                    key: "paymentType",
                    tag: "vSelect",
                    options: [
                        {
                            value: "payment",
                            label: this.$t("boss.purchase.self_procurement", {
                                defaultValue: "自采",
                            }),
                        },
                        {
                            value: "unpayment",
                            label: this.$t("boss.purchase.agency_operations", {
                                defaultValue: "代运营",
                            }),
                        },
                        {
                            value: "undefined",
                            label: this.$t("boss.purchase.other", {
                                defaultValue: "其他",
                            }),
                        },
                    ],
                },
                {
                    label: this.$t("boss.purchase.purchase_currency", {
                        defaultValue: "采购币种",
                    }),
                    key: "currency",
                },
                {
                    label: this.$t("boss.purchase.inspection_status", {
                        defaultValue: "验货状态",
                    }),
                    key: "inspectStatus",
                    tag: "vSelect",
                    options: [
                        {
                            value: 0,
                            label: this.$t("boss.purchase.uninspected_goods", {
                                defaultValue: "未验货",
                            }),
                        },
                        {
                            value: 1,
                            label: this.$t(
                                "boss.purchase.qualified_inspection",
                                {
                                    defaultValue: "验货合格",
                                }
                            ),
                        },
                        {
                            value: 2,
                            label: this.$t(
                                "boss.purchase.unqualified_inspection",
                                {
                                    defaultValue: "验货不合格",
                                }
                            ),
                        },
                    ],
                },
                {
                    label: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                },
            ];
        },
        getDeliverData() {
            return {
                initFormData: {
                    id: this.activeid,
                },
                ajaxRequest: HttpGetDeliverList,
                startUp: true,
                columns: [
                    {
                        title: "ERPSKU",
                        key: "erpsku",
                    },
                    {
                        title: this.$t(
                            "boss.purchase.actual_purchase_quantity",
                            {
                                defaultValue: "实际采购数量",
                            }
                        ),
                        render(h, { row }) {
                            let inFactNum = Number(
                                row.poQuantity -
                                    (row.poCancelQuantity
                                        ? row.poCancelQuantity
                                        : 0)
                            );
                            return <div>{inFactNum}</div>;
                        },
                    },
                    {
                        title: this.$t("boss.purchase.purchase_quantity", {
                            defaultValue: "采购数量",
                        }),
                        key: "poQuantity",
                    },
                    {
                        title: this.$t("boss.purchase.delivery_quantity", {
                            defaultValue: "交货数量",
                        }),
                        key: "deliverQuantity",
                    },
                    {
                        title: this.$t("boss.purchase.box_no", {
                            defaultValue: "箱号",
                        }),
                        key: "cartonNo",
                    },
                    {
                        title: this.$t("boss.purchase.delivery_date", {
                            defaultValue: "交货日期",
                        }),
                        key: "deliverDate",
                    },
                    {
                        title: this.$t("boss.purchase.notes", {
                            defaultValue: "备注",
                        }),
                        key: "remark",
                    },
                    {
                        title: this.$t("boss.purchase.update_time", {
                            defaultValue: "更新时间",
                        }),
                        key: "createdAt",
                    },
                ],
            };
        },
        creacolumns() {
            return [
                {
                    title: "ERPSKU",
                    key: "erpsku",
                },
                {
                    title: this.$t("boss.purchase.actual_purchase_quantity", {
                        defaultValue: "实际采购数量",
                    }),
                    render(h, { row }) {
                        let inFactNum = Number(
                            row.quantity -
                                (row.cancelQuantity ? row.cancelQuantity : 0)
                        );
                        return <div>{inFactNum}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.purchase_quantity", {
                        defaultValue: "采购数量",
                    }),
                    key: "quantity",
                },
                {
                    title: this.$t("boss.purchase.delivered_quantity", {
                        defaultValue: "已交货数量",
                    }),
                    key: "deliverQuantity",
                },
                {
                    title: this.$t("boss.purchase.undelivered_quantity", {
                        defaultValue: "未交货数量",
                    }),
                    render(h, { row }) {
                        // return <div>{((row.quantity-row.deliverQuantity)<0 ? 0 : (row.quantity-row.deliverQuantity)).toFixed(2)}</div>
                        return (
                            <div>
                                {row.quantity - row.deliverQuantity < 0
                                    ? 0
                                    : row.quantity - row.deliverQuantity}
                            </div>
                        );
                    },
                },
                {
                    key: "importDeliverQuantity",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                                style: "margin-right:5px",
                            }),
                            h(
                                "strong",
                                this.$t(
                                    "boss.purchase.quantity_this_delivery",
                                    {
                                        defaultValue: "本次交货数量",
                                    }
                                )
                            ),
                        ]);
                    },
                    render: (h, { row, index }) => {
                        return h("vInputNumber", {
                            props: {
                                // size:'small',
                                value: row.importDeliverQuantity,
                                min: 0,
                            },
                            on: {
                                input: (event) => {
                                    row.importDeliverQuantity = event;
                                    this.creaformList[index] = row;
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("boss.purchase.delivery_date", {
                        defaultValue: "交货日期",
                    }),
                    key: "deliverDate",
                    renderHeader: (h, params) => {
                        let addbutton = "";
                        if (this.creaformList.length > 1) {
                            addbutton = h(
                                "span",
                                {
                                    style: {
                                        display: "inline-block",
                                        cursor: "pointer",
                                        "margin-left": "10px",
                                    },
                                },
                                [
                                    h(
                                        "Tooltip",
                                        {
                                            props: {
                                                placement: "top",
                                                // transfer:true,
                                                content: this.$t(
                                                    "boss.purchase.following_rows",
                                                    {
                                                        defaultValue:
                                                            "点击该按钮，将以第一行的交货日期，填充以下所有行本次交货日期的框内",
                                                    }
                                                ),
                                            },
                                        },
                                        [
                                            h("Icon", {
                                                props: {
                                                    type: "md-albums",
                                                    color: "#2d8cf0",
                                                },
                                                on: {
                                                    click: () => {
                                                        this.filldate();
                                                    },
                                                },
                                                style: {
                                                    "font-size": "15px",
                                                },
                                            }),
                                        ]
                                    ),
                                ]
                            );
                        }
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                                style: "margin-right:5px",
                            }),
                            h(
                                "strong",
                                this.$t("boss.purchase.delivery_date", {
                                    defaultValue: "交货日期",
                                })
                            ),
                            addbutton,
                        ]);
                    },
                    render: (h, { row, index }) => {
                        return h("DatePicker", {
                            props: {
                                type: "date",
                                format: "yyyy-MM-dd",
                                placeholder: "Select date",
                                value: this.creaformList[index].deliverDate,
                            },
                            on: {
                                "on-change": (date) => {
                                    // console.log(date)
                                    // row.deliverDate = event;
                                    this.creaformList[index].deliverDate = date;
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("boss.purchase.box_no", {
                        defaultValue: "箱号",
                    }),
                    key: "cartonNo",
                    render: (h, { row, index }) => {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.cartonNo,
                            },
                            on: {
                                input: (event) => {
                                    row.cartonNo = event;
                                    this.creaformList[index] = row;
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                    render: (h, { row, index }) => {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.remark,
                            },
                            on: {
                                input: (event) => {
                                    row.remark = event;
                                    this.creaformList[index] = row;
                                },
                            },
                        });
                    },
                },
            ];
        },
        getFileProps() {
            return {
                data: {
                    supplierId: this.formData.supplierId || 0,
                    currency: this.formData.currency,
                    poId: this.id,
                },
                action:
                    process.env.VUE_APP_APIURL_BOSS + this.operate.actionurl,
                name: "excelFile",
                warningtitle: this.$t("boss.purchase.overwrite_update", {
                    defaultValue:
                        "该导入为覆盖更新，如果有过交货记录，导入后将以新数据覆盖！",
                }),
                download: () => {
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_BOSS +
                            this.operate.downexcel,
                        {},
                        "download"
                    );
                },
            };
        },
    },
    methods: {
        filldate() {
            console.log(this.creaformList[0].deliverDate);
            if (!this.creaformList[0].deliverDate) {
                this.$VMessage.error(
                    this.$t("boss.purchase.fill_first_date", {
                        defaultValue: "请填写第一个日期",
                    })
                );
                return;
            }
            let date = this.creaformList[0].deliverDate;
            this.creaformList.map((item, index) => {
                this.creaformList[index].deliverDate = date;
                this.$set(this.creaformList, index, {
                    deliverDate: date,
                    id: item.id,
                    orderNo: item.orderNo,
                    productId: item.productId,
                    erpsku: item.erpsku,
                    price: item.price,
                    quantity: item.quantity,
                    deliverQuantity: item.deliverQuantity,
                    remark: item.remark,
                    poRequisitionOrderNo: item.poRequisitionOrderNo,
                    importDeliverQuantity: item.importDeliverQuantity,
                    cartonNo: item.cartonNo,
                });
            });
            // this.creaformList = this.creaformList;
            // console.log(this.creaformList)
            // this.$set(this.$data,'creaformList',this.creaformList)
        },
        update() {
            this.loading = true;
            // 请求详情内容和交货记录
            if (this.querytype) {
                this.id = this.activeid;
            }
            HttpGetOrderOne({
                id: this.id,
            }).then(
                (res) => {
                    this.loading = false;
                    this.formData = res.data;
                    this.creaformList = res.data.poOrderItem;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                    this.loading = false;
                }
            );

            HttpGetDeliverOne({
                id: this.id,
            }).then(
                (res) => {
                    this.delyformList = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        importexcel() {
            this.operate = {
                show: true,
                title: this.$t("boss.purchase.import_data", {
                    defaultValue: "导入数据",
                }),
                actionurl: "/api/v2/po/importDeliverExcel",
                downexcel: "/api/v2/po/downDeliverExcel",
            };
        },
        // 点击上传附件之后的操作
        aaasuccess(res) {
            // console.log(res)
            this.creaformList = res.data;
            this.update();
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
        submit() {
            let vmflag = false;
            let resultArr = this.creaformList.filter((item) => {
                if (
                    item.importDeliverQuantity === 0 ||
                    !item.importDeliverQuantity
                ) {
                    vmflag = true;
                } else {
                    return item;
                }
            });
            if (resultArr.length < 1) {
                return this.$VMessage.error(
                    this.$t("boss.purchase.delivery_date_a", {
                        defaultValue: "请填写交货数量和交货日期！",
                    })
                );
            }

            this.loading = true;
            HttpSaveDeliver({
                poId: this.id,
                items: resultArr,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancel();
                    this.$emit("on-update");
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            // this.$router.push({
            //     name: 'purchaseOrderList',
            // })
            this.$emit("on-close");
        },
    },
};
</script>
